import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { shake } from '../../animation.vanilla.mjs';
import AnimationController from './AnimationController.mjs';

const SHAKING_ANIMATION_DURATION = 0.3;
const SHAKING_ANIMATION_EASING = "ease-in-out";
const ShakingAnimation = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(
    AnimationController,
    {
      animation: shake,
      duration: SHAKING_ANIMATION_DURATION,
      easing: SHAKING_ANIMATION_EASING,
      ref,
      ...props
    }
  );
});

export { ShakingAnimation };
//# sourceMappingURL=ShakingAnimation.mjs.map
